import { IGroupTemplate } from 'fitbeat.models';
import React from 'react';
import IntlMessages from '../../../util/IntlMessages';

interface ITemplateRowProps {
  template: IGroupTemplate;
  checked: boolean;
  alreadyCreated: boolean;
  isSaving: boolean;
  onToggle: (templateId: string) => void;
}

const TemplateRow: React.FC<ITemplateRowProps> = ({
  template,
  checked,
  alreadyCreated,
  isSaving,
  onToggle,
}) => (
  <label className={`group-catalogue__row${alreadyCreated ? ' group-catalogue__row--disabled' : ''}`}>
    <input
      type='checkbox'
      checked={checked && !alreadyCreated}
      disabled={alreadyCreated || isSaving}
      onChange={() => onToggle(template._id)}
    />
    <img src={template.imageUrl} alt='' className='group-catalogue__thumbnail' />
    <div className='group-catalogue__row-text'>
      <div className='group-catalogue__row-name'>
        {template.name}
        {alreadyCreated && (
          <span className='group-catalogue__tag'><IntlMessages id='groups.catalogue.alreadyCreated' /></span>
        )}
      </div>
      <div className='group-catalogue__row-description'>{template.description.split('\n')[0]}</div>
    </div>
  </label>
);

export default TemplateRow;
